

















import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '@/models/event';

import Modal from './base/Modal.vue';
import EventList from './EventList.vue';

@Component({
  components: {
    Modal,
    EventList,
  },
})
export default class EventListModalComponent extends Vue {
  @Prop({ required: true })
  private events!: Array<Event>;

  @Prop({ required: true })
  private selected!: Event;

  private modal: Modal;

  mounted() {
    this.modal = this.$refs.modal as Modal;
  }

  onEdit(event: Event) {
    this.$emit('on-edit', event);
    this.close();
  }

  onSelect(event: Event) {
    this.$emit('on-select', event);
    this.close();
  }

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }
}
